export const navbarBurger = (function ($) {

    const $navbar = $(".js-navbar");
    const $navbarBurger = $(".js-navbar-burger");
    const $navbarClose = $(".js-navbar-close");

    function init() {
        $navbarBurger.on("click", function () {
            let dataTarget = $(this).attr('data-target');
            let $navbarTarget = $('#'+dataTarget);
            let $selectedMenu = $(".is-menu-selected");
            const $navbarBurgerActive = $(".js-navbar-burger.is-active");

            // remove selected class from every menu
            $selectedMenu.removeClass("is-menu-selected")

            // remove active class from every navbar button
            $navbarBurgerActive.removeClass("is-active")

            if ($navbar.hasClass("is-active")) {
                $(this).attr('aria-expanded', false);
                $navbar.removeClass("is-active");
                $('html').removeClass('no-overflow');
            } else {
                $(this).attr('aria-expanded', true);
                $navbarTarget.addClass("is-menu-selected");
                $navbar.addClass("is-active");
                $(this).addClass("is-active");
                $('html').addClass('no-overflow');
                setTimeout(() => {
                    $("#main-navbar").removeClass('header-unpin').addClass('header-pin');
                }, 350)
            }
        });

        $navbarClose.on("click", function () {
            let $selectedMenu = $(".is-menu-selected");
            const $navbarBurgerActive = $(".js-navbar-burger.is-active");

            // remove selected class from every menu
            $selectedMenu.removeClass("is-menu-selected")

            // remove active class from every navbar button
            $navbarBurgerActive.removeClass("is-active")

            $navbar.removeClass("is-active");
            $('html').removeClass('no-overflow');

        });

    }

    return {
        init: init
    }

})(jQuery);
